import{jsx as e,jsxs as o}from"react/jsx-runtime";import{styled as r}from"styled-components";import{FIRST_COL_WIDTH as t}from"./constants.mjs";import{draggableLineStyle as i}from"./style.mjs";import{useDraggingToFrozeColumn as a}from"./useDraggingToFrozeColumn.mjs";import{explanationName as n}from"../../../../domain/domain/UI/Explanation.name.mjs";import{useItemNames as s}from"../../../../domain/hooks/useItemName.mjs";const l=r.div`
  grid-row: 1;
  grid-column: 1;
  z-index: 6;
  position: sticky;
  top: 0px;
  left: ${t}px;
`,m=r.div`
  position: relative;
  background-color: #c5dfec;
  height: 30px;
  opacity: 0.25;
  cursor: e-resize;
`,d=r.div`
  position: absolute;
  width: 0px;
  border-right: 2px solid black;
  border-top: 0;
  border-bottom: 0;
  border-left: 0;
  margin-left: -2px;
  opacity: 1;
`,g=r.div`
  position: absolute;
  top: 0px;
  right: 0px;
  background: url(images/drag_pointer.png) no-repeat scroll center right transparent;
  width: 10px;
  height: 30px;
`;function p({gridRef:r,columnMetrics:t,setColumns:p}){const c=s(n),{widgetStyle:b,draggableAreaRef:u,startDragging:f}=a(r,t,p);return e(l,{className:"column-lock",children:o(m,{ref:u,className:"draggable-area",title:c("draggableAreaTitle"),onMouseDown:f,style:{width:b.draggableAreaWidth},children:[e(d,{className:"draggable-line",style:i(b.draggableLineLeft,r)}),e(g,{className:"draggable-pointer"})]})})}export{p as ColumnLock};
